import { useCallback, useEffect, useLayoutEffect, useState } from "react";

import type { Editor, EditorConfig, EditorReadyHandler, ProjectDataChangeHandler } from "./types";
import type { FC } from "react";

interface DesignHuddleEditorProps extends EditorConfig {
  onReady?: EditorReadyHandler;
  onChange?: ProjectDataChangeHandler;
}

export const DesignHuddleEditor: FC<DesignHuddleEditorProps> = ({
  onReady,
  onChange,
  project_id,
  ...config
}) => {
  const [initialized, setInitialized] = useState(false);
  const [editor, setEditor] = useState<Editor>();
  const editorRef = useCallback(
    (instance: HTMLDivElement | null) => {
      if (!editor && instance?.id) {
        DSHDLib.Editors.insert(
          instance.id,
          {
            project_id,
            ...config,
          },
          (err, e) => {
            if (err) {
              console.error(err);
            } else {
              setEditor(e);
            }
          },
        );
      }
    },
    [editor, project_id, config],
  );

  useEffect(() => {
    if (editor && !initialized) {
      if (onChange)
        editor.handleProjectDataModification(
          (cb, options) => {
            console.log("Project data changed");
            onChange(cb, options);
          },
          { user_modifications_only: true },
        );

      editor.onInitialized(() => {
        setInitialized(true);
        onReady?.(editor);
      });
    }
  }, [editor, onReady, initialized, onChange]);

  useLayoutEffect(
    () => () => {
      try {
        editor?.remove();
      } catch (error) {
        // editor is already removed
        console.error(error);
      }
    },
    [editor],
  );

  return (
    <div
      style={{
        height: "100%",
      }}
      ref={editorRef}
      id={`designHuddle-${project_id}`}
      data-testid={`designHuddle-${project_id}`}
    />
  );
};
